import React, { useEffect } from "react";
import "./ProviderOverviewSection.scss";
import { useState } from "react";
import CgFormCreator from "../../../common/CgFormCreator";
import PopupModal from "../../../common/PopupModal";
import "bootstrap-icons/font/bootstrap-icons.scss";
import { useDispatch, useSelector } from "react-redux";
import ExamplePhoto from "../../../assets/images/exampleProfilePhoto.png";
import CgCarousel from "../../../common/CgCarousel";
import ImageUpload from "../../../common/ImageUpload";
import {
  fetchDeleteProvidersPhotos,
  fetchProviderInformation,
  fetchProvidersPhotos,
  fetchUpdateProviderInformation,
  fetchUpdateProvidersPhotos,
} from "../../../store/ProviderInfo/ProviderOverviewActions";
import { useLocation } from "react-router-dom";
import {
  convertMMYYYYToYYYYMMDDWithGivenDay,
  convertYYYYMMDDToMMYYYY,
  convertYYYYMMDDToMMDDYYYY,
  convertMMDDYYYYToYYYYMMDD,
  MONTH_YEAR_REGEX,
  DATE_REGEX,
  EMAIL_REGEX,
  PHONE_NUMBER_REGEX,
  getIsTheValueNotMatchedWithRegex,
} from "../../../utils/commonUtilities";
import defaultProfileIcon from "../../../assets/images/defaultProfileIcon.svg";
import redAlert from "../../../assets/images/redAlert.svg";
import { ToastBanner } from "../../../common/ToastBanner";
import {
  fetchProviderPhotosList,
  fetchProviderProfilePhoto,
} from "../../../store/ProviderInfo/ProviderPhotosActions";

const genderRadioOptions = [
  {
    code: "male",
    name: "Male",
  },
  {
    code: "female",
    name: "Female",
  },
];

const sufixData = [
  { id: 0, value: "None" },
  { id: 1, value: "Jr" },
  { id: 2, value: "Sr" },
  { id: 3, value: "II" },
  { id: 4, value: "III" },
  { id: 5, value: "IV" },
  { id: 6, value: "V" },
  { id: 7, value: "VI" },
  { id: 8, value: "VII" },
  { id: 9, value: "VIII" },
  { id: 10, value: "IX" },
];

const getIsFieldNotValid = ({ formData, field }) => {
  if (field.required && field.type === "text") {
    return !formData[field.name]?.trim();
  }

  if (formData[field.name] && field?.inputProps?.pattern) {
    return getIsTheValueNotMatchedWithRegex({
      pattern: field?.inputProps?.pattern,
      value: formData[field.name],
      required: Boolean(field.required),
    });
  }
};
const ProviderOverviewSection = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmPhotoDelete, setConfirmPhotoDelete] = useState(false);
  const [showProfilePhoto, setShowProfilePhoto] = useState(true);
  const [popupState, setPopupState] = useState(""); // photos
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [carouselSelectedImg, setCarouselSelectedImg] = useState();
  const [renderImage, setRenderImage] = useState(null);
  const [resetImgValue, setResetImgValue] = useState(false);
  const [showError, setShowError] = useState(false);
  const [rawUploadedFile, setRawUploadedFile] = useState(null);
  const [reloadDateOfBirthFutureError, setReloadDateOfBirthFutureError] =
    useState(0);

  /**
   *  Updated providerOverViewRef from a useRef to a state variable for consistency with previous data structures (added current).
   *  Switched from ref to state to enable disabling the save button as required in production.
   */
  const [providerOverViewRef, setProviderOverViewRef] = useState({
    current: {},
  });

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const providersId = locationHeaderData[2];

  const dispatch = useDispatch();

  const {
    isProviderOverviewDataLoading,
    providerOverviewData,
    providerOverviewErrorMsg,
  } = useSelector((state) => state.providerOverviewInformation);
  const { profilePhotosData, isProfilePhotosLoading, profilePhotosErrorMsg } =
    useSelector((state) => state.providerOverviewPhotos);
  const { photosData } = useSelector((state) => state.providerPhotosList);

  useEffect(() => {
    dispatch(fetchProviderPhotosList(providersId));
    dispatch(fetchProviderProfilePhoto(providersId));
  }, []);

  useEffect(() => {
    dispatch(fetchProviderInformation(providersId));
    dispatch(fetchProvidersPhotos(providersId));
  }, [providersId]);

  useEffect(() => {
    if (providerOverviewErrorMsg || profilePhotosErrorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [providerOverviewErrorMsg, profilePhotosErrorMsg]);

  useEffect(() => {
    if (profilePhotosData?.image?.large) {
      setRenderImage(profilePhotosData?.image?.large);
      setShowProfilePhoto(true);
    } else {
      setShowProfilePhoto(false);
      // setRenderImage(defaultProfileIcon);
    }
  }, [profilePhotosData]);

  const editOverviewFormSchema = [
    {
      component: "input",
      label: "FIRST NAME",
      type: "text",
      name: "firstName",
      required: true,
      defaultValue: providerOverviewData?.firstName,
      onKeyChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
    },
    {
      component: "input",
      label: "MIDDLE NAME",
      type: "text",
      name: "middleName",
      required: false,
      defaultValue: providerOverviewData?.middleName,
      valueChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
    },
    {
      component: "input",
      label: "LAST NAME",
      type: "text",
      name: "lastName",
      required: true,
      defaultValue: providerOverviewData?.lastName,
      onKeyChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
    },
    {
      component: "input",
      label: "GOES BY (ALTERNATE FIRST NAME)",
      type: "text",
      name: "alternateFirstName",
      required: false,
      defaultValue: providerOverviewData?.nickName,
      valueChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
    },
    {
      component: "dropdown",
      label: "SUFFIX",
      name: "suffix",
      dropdownOptions: sufixData,
      defaultValue: providerOverviewData?.suffix || "None",
      onSelectCallBack: (name, value) => {
        handleUpdateFormData(name, value);
      },
      required: false,
    },
    {
      component: "radio",
      name: "gender",
      defaultValue: providerOverviewData?.gender,
      options: genderRadioOptions,
      keyValues: { label: "name", value: "code" },
      onSelect: (name, value) => {
        handleUpdateFormData(name, value);
      },
      customRenderLabel: () => {
        return <div>GENDER</div>;
      },
    },
    {
      customDateDisplay: true,
      placeholder: "mm/dd/yyyy",
      component: "input",
      label: "DATE OF BIRTH",
      type: "date",
      name: "dateOfBirth",
      defaultValue:
        convertYYYYMMDDToMMDDYYYY(providerOverviewData?.dateOfBirth) || "",
      required: false,
      onKeyChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
      inputProps: {
        pattern: DATE_REGEX,
      },
    },
    {
      component: "input",
      label: "PROVIDER EMAIL",
      type: "email",
      name: "email",
      required: false,
      defaultValue: providerOverviewData?.email,
      onKeyChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
      inputProps: {
        pattern: EMAIL_REGEX,
        title: "Please enter a valid email address",
      },
    },
    {
      component: "input", // need to udate the callback once checkbox is added
      label: "NPI",
      type: "text",
      name: "nationalProviderIdentifier",
      required: false,
      defaultValue:
        !providerOverviewData?.npiUnavailable &&
        providerOverviewData?.nationalProviderIdentifier,
      showCheckbox: true,
      onCheckboxValueChange: (value) => {
        handleUpdateFormData("npiUnavailable", value);
      },
      checkboxLabel: "NPI not available",
      checkboxDefaultValue: providerOverviewData?.npiUnavailable,
      onKeyChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
      inputProps: {
        pattern: PHONE_NUMBER_REGEX,
      },
      shouldRenderInputCheckboxWithBackgroundImageStyle: true,
    },
    {
      customDateDisplay: true,
      placeholder: "mm/yyyy",
      maxLength: 7,
      component: "input",
      label: "PRACTICE SINCE",
      type: "month",
      name: "inPracticeSinceDate",
      required: false,
      defaultValue: providerOverviewData?.inPracticeSinceDate
        ? convertYYYYMMDDToMMYYYY(providerOverviewData.inPracticeSinceDate)
        : "",
      onKeyChangeCallback: (name, value) => {
        handleUpdateFormData(name, value);
      },
      inputProps: {
        pattern: MONTH_YEAR_REGEX,
      },
    },
  ];

  const handleProviderPhotoDelete = () => {
    setRenderImage(defaultProfileIcon);
    setShowProfilePhoto(!showProfilePhoto);
    setConfirmPhotoDelete(!confirmPhotoDelete);
    dispatch(
      fetchDeleteProvidersPhotos({
        providersId,
        displayId: profilePhotosData?.displayId,
      })
    );
    // this will be an api call to remove photo
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsDropdownVisible(false);
  };

  const handlePencilClick = () => {
    setIsDropdownVisible(true);
  };

  const validateDateOfBirth = () => {
    if (!providerOverViewRef.current?.dateOfBirth) {
      return true;
    }

    const dateOfBirth = new Date(providerOverViewRef.current?.dateOfBirth);
    const currentDate = new Date();
    return dateOfBirth <= currentDate;
  };

  const handleUpdateFormData = (name, value) => {
    setProviderOverViewRef((prev) => ({
      current: {
        ...prev.current,
        [name]: value,
      },
    }));
  };

  const handleUpdateProviderOverviewData = () => {
    const updateState = { ...providerOverviewData };

    Object.keys(providerOverViewRef.current).forEach((key) => {
      if (key in updateState) {
        updateState[key] = providerOverViewRef.current[key];
      }
    });

    const payload = {
      firstName:
        providerOverViewRef.current?.firstName || updateState?.firstName || "",
      lastName:
        providerOverViewRef.current?.lastName || updateState?.lastName || "",
      middleName:
        providerOverViewRef.current?.middleName ||
        updateState?.middleName ||
        "",
      suffix:
        providerOverViewRef.current?.suffix === "None"
          ? ""
          : providerOverViewRef.current?.suffix || updateState?.suffix || "",
      nickName:
        providerOverViewRef.current?.alternateFirstName ||
        updateState?.nickName ||
        "",
      gender: providerOverViewRef.current?.gender || updateState?.gender || "",
      email: providerOverViewRef.current?.email || updateState?.email || "",
      dateOfBirth:
        convertMMDDYYYYToYYYYMMDD(providerOverViewRef.current?.dateOfBirth) ||
        updateState?.dateOfBirth ||
        "",
      inPracticeSinceDate:
        convertMMYYYYToYYYYMMDDWithGivenDay(
          providerOverViewRef.current?.inPracticeSinceDate,
          providerOverviewData?.inPracticeSinceDate
        ) ||
        updateState?.inPracticeSinceDate ||
        "",
      inPracticeSinceYear:
        providerOverViewRef.current?.inPracticeSinceYear ||
        updateState?.inPracticeSinceYear ||
        "",
      specialtyCodes:
        providerOverViewRef.current?.specialtyCodes ||
        updateState?.specialtyCodes ||
        "",
      nationalProviderIdentifier:
        providerOverViewRef.current?.nationalProviderIdentifier ||
        updateState?.nationalProviderIdentifier ||
        "",
      npiUnavailable:
        providerOverViewRef.current?.npiUnavailable !== undefined
          ? providerOverViewRef.current?.npiUnavailable
          : updateState?.npiUnavailable,
      state: providerOverViewRef.current?.state || updateState?.state || "",
      profilePhoto:
        providerOverViewRef.current?.profilePhoto ||
        updateState?.profilePhoto ||
        "",
      yearsOfExperience:
        providerOverViewRef.current?.yearsOfExperience ||
        updateState?.yearsOfExperience ||
        "",
    };

    dispatch(fetchUpdateProviderInformation({ providersId, payload })).then(
      (response) => {
        if (response?.payload?.success) {
          dispatch(fetchProviderInformation(providersId));
        }
      }
    );
  };

  const RenderProvidersError = () => {
    if (!showError) return null;
    return (
      <div
        className="overlay-alert alert alert-danger alertTopPosition"
        role="alert"
      >
        {providerOverviewErrorMsg || profilePhotosErrorMsg}
      </div>
    );
  };

  // Render Fucntions
  const RenderEditProviderOverview = () => {
    if (popupState === "photos") return null;
    if (isProviderOverviewDataLoading) return null;
    const RenderFormCreator = () => {
      return (
        <div className="editProviderWrapper">
          <CgFormCreator
            key={providerOverviewData}
            onCancel={() => {
              setOpenPopup(false);
              setPopupState("");
            }}
            resetFormValues={!openPopup ? true : false}
            noSubmit
            needFormHeader
            formHeader="PROVIDER INFORMATION"
            formClassName="providerOverViewFormWrapper"
            schema={editOverviewFormSchema}
          />
        </div>
      );
    };

    if (!openPopup) {
      return null;
    }

    return (
      <>
        <PopupModal
          width="70%"
          customRender={RenderFormCreator}
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setPopupState("");
          }}
          onSave={(res) => {
            if (!validateDateOfBirth()) {
              setReloadDateOfBirthFutureError((prev) => prev + 1);
              return;
            }
            handleUpdateProviderOverviewData(res);
            setOpenPopup(!openPopup);
            setPopupState("");
          }}
          popupHeading="PROVIDER INFORMATION"
          enableSave
          disableSave={editOverviewFormSchema.some((field) => {
            if (providerOverViewRef.current[field.name] === undefined) {
              // User hasn't edited this field, so no need to do any sort of validation
              return false;
            }

            return getIsFieldNotValid({
              formData: providerOverViewRef.current,
              field,
            });
          })}
        />
        {reloadDateOfBirthFutureError ? (
          <ToastBanner
            key={reloadDateOfBirthFutureError}
            title="Date of Birth cannot be in the future."
            duration={5500}
          />
        ) : null}
      </>
    );
  };

  const RenderConfirmPhotoDeleteModal = () => {
    return (
      <div className="confirmDeleteBtnWrapper">
        <div className="confirmText"> Delete Photo ? </div>
        <div
          className="yesBt"
          onClick={() => {
            handleProviderPhotoDelete();
          }}
        >
          YES
        </div>
        <div
          className="noBtn"
          onClick={() => {
            setConfirmPhotoDelete(!confirmPhotoDelete);
          }}
        >
          NO
        </div>
      </div>
    );
  };

  const RenderUploadImageJsx = () => {
    return (
      <div className="imgUplodWrapper">
        <div className="imgUpload">
          <img src={defaultProfileIcon} alt="" height="50px" width="50px" />
          <div className="inputFieldText">
            <div className="text-center">
              Drag photo here or
              <span className="linkColor"> browse </span>
              to upload a new photo
            </div>
            <p className="supportedFileText">
              Supported file types: .png, .gif, .jpg, .jpeg
            </p>
          </div>
        </div>
      </div>
    );
  };

  const RenderPhotosEditPopup = () => {
    if (popupState === "overview") return null;

    const RenderPhotos = () => {
      return (
        <div className="photosWrapper">
          <div className="photosSectionWrapper1">
            <div className="instructionImgWrapper">
              <img alt="" src={ExamplePhoto} />
            </div>
            <div className="instructionListWrapper">
              <div>
                <h6 className="instructionHeader">
                  How to select a good profile photo
                </h6>
                <div className="instructionLines">
                  - Use a photo of the provider looking at the camera
                </div>
                <div className="instructionLines">
                  - Crop away any unnecessary background that makes the photo
                  look busy
                </div>
                <div className="instructionLines">
                  - Make sure the provider is smiling and looks professional
                </div>
              </div>
            </div>
          </div>
          <div className="photosSectionWrapper2">
            <ImageUpload
              resetValue={resetImgValue}
              key={selectedPhoto}
              renderCustom={RenderUploadImageJsx}
              isRenderCustom
              handleGetFormData={(res) => {
                setRawUploadedFile(res);
              }}
              uploadedImage={selectedPhoto}
              onCropComplete={(res, url) => {
                setCarouselSelectedImg(url);
              }}
              fileUploaded={(res) => {
                setCarouselSelectedImg(res);
              }}
            />
            <div className="carouselWrapper">
              <CgCarousel
                images={Object.values(photosData ?? {}).map(
                  (photo) => photo.image.medium
                )}
                selectedPhoto={(img) => {
                  setSelectedPhoto(img);
                  setCarouselSelectedImg(img);
                }}
              />
            </div>
            <div className="photosBtnWrapper">
              <button
                className="saveBtn"
                onClick={() => {
                  const formData = new FormData();
                  formData.append("file", rawUploadedFile);
                  dispatch(
                    fetchUpdateProvidersPhotos({
                      providersId,
                      payload: formData,
                    })
                  ).then(() => {
                    dispatch(fetchProvidersPhotos(providersId));
                  });
                  setOpenPopup(!openPopup);
                  setRenderImage(carouselSelectedImg);
                  setSelectedPhoto("");
                  setShowProfilePhoto(true);
                }}
              >
                SAVE PROFILE PHOTO
              </button>
              <button
                className="cancelBtn"
                onClick={() => {
                  setOpenPopup(false);
                  setPopupState("");
                  setResetImgValue(false);
                }}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="photosEditWrapper">
        <PopupModal
          customRender={RenderPhotos}
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setPopupState("");
          }}
          onSave={() => {
            setOpenPopup(!openPopup);
            setPopupState("");
          }}
          popupHeading="UPDATE PROFILE PHOTO"
        />
      </div>
    );
  };

  return (
    <>
      {isProviderOverviewDataLoading ? (
        <div>Loading ...</div>
      ) : (
        <div className="provider-overview">
          <div className="overviewHeader">
            <h3 className="section-header top-thirty overview">
              Overview
              <a
                className="btn edit-button"
                onClick={() => {
                  /**
                   *  Resetting this to its initial state before opening the form, to match production functionality.
                   */
                  setProviderOverViewRef({
                    current: {},
                  });
                  setReloadDateOfBirthFutureError(0);
                  setOpenPopup(!openPopup);
                  setPopupState("overview");
                }}
              >
                Edit
              </a>
            </h3>
            {!providerOverviewData?.dateOfBirth && (
              <div className="missing-data-info">
                <div>
                  <img
                    className="missing-data-img"
                    src={redAlert}
                    alt="Missing Info Image"
                  />
                </div>
                <div className="missing-data">
                  <p> MISSING DATA</p>
                </div>
              </div>
            )}
          </div>
          <div className="overview-table-items">
            <div
              className="img-bg border border-end-0"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {isProfilePhotosLoading ? (
                <div> Loading .... </div>
              ) : (
                <>
                  {showProfilePhoto && (
                    <img
                      className="showImg"
                      alt="photo"
                      height="160px"
                      width="160px"
                      src={renderImage}
                    />
                  )}
                  {!showProfilePhoto && (
                    <div
                      className="addImgWrapper"
                      onClick={() => {
                        setOpenPopup(true);
                        setPopupState("photos");
                        setResetImgValue(false);
                      }}
                    >
                      <img
                        className="noImg"
                        style={{ backgroundColor: "transparent" }}
                        alt="photo"
                        height="100px"
                        width="100px"
                        src={defaultProfileIcon}
                      />
                      <div className="btnText"> + Add Photo </div>
                    </div>
                  )}
                </>
              )}
              {!confirmPhotoDelete && isHovered && (
                <button
                  type="button"
                  className="pencil-icon"
                  onClick={handlePencilClick}
                >
                  {!confirmPhotoDelete && showProfilePhoto && (
                    <i className="bi bi-pencil-fill"></i>
                  )}
                </button>
              )}
              {isDropdownVisible && (
                <div className="img-update-deletedropdown">
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item dropdown-item-divider"
                      onClick={() => {
                        setOpenPopup(true);
                        setPopupState("photos");
                        setResetImgValue(false);
                      }}
                    >
                      Update
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        setConfirmPhotoDelete(!confirmPhotoDelete);
                        setIsDropdownVisible(!isDropdownVisible);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              )}
              {confirmPhotoDelete && RenderConfirmPhotoDeleteModal()}
            </div>
            <div className="overview-table-items-2">
              <div className="row border">
                <div className="col-md-4">
                  <div className="table-content">
                    <p className="header">GENDER</p>
                    <p className="headerValue">
                      {providerOverviewData?.gender}
                    </p>
                  </div>
                </div>
                <div className="col-md-4 border-start border-end">
                  <div className="table-content">
                    <p
                      className={`header ${
                        !providerOverviewData?.nationalProviderIdentifier
                          ? "error-label"
                          : ""
                      }`}
                    >
                      NPI
                    </p>
                    {providerOverviewData?.nationalProviderIdentifier ? (
                      <p className="headerValue">
                        {providerOverviewData?.nationalProviderIdentifier}
                      </p>
                    ) : (
                      <a
                        className="update-info-link"
                        onClick={() => {
                          setOpenPopup(!openPopup);
                          setPopupState("overview");
                        }}
                      >
                        Add NPI
                      </a>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="table-content">
                    <p className="header">YEARS IN PRACTICE</p>
                    {providerOverviewData?.yearsOfExperience ? (
                      <p className="headerValue">
                        {providerOverviewData?.yearsOfExperience}
                      </p>
                    ) : (
                      <a
                        className="update-info-link"
                        onClick={() => {
                          setOpenPopup(!openPopup);
                          setPopupState("overview");
                        }}
                      >
                        Add Years in Practice
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="row border border-top-0">
                <div className="col-md-4">
                  <div className="table-content">
                    <p
                      className={`header ${
                        !providerOverviewData?.dateOfBirth ? "error-label" : ""
                      }`}
                    >
                      DATE Of BIRTH
                    </p>
                    {providerOverviewData?.dateOfBirth ? (
                      <p className="headerValue">
                        {providerOverviewData?.dateOfBirth}
                      </p>
                    ) : (
                      <a
                        className="update-info-link"
                        onClick={() => {
                          setOpenPopup(!openPopup);
                          setPopupState("overview");
                        }}
                      >
                        Add Date of Birth
                      </a>
                    )}
                  </div>
                </div>
                <div className="col-md-8 border-start">
                  <div className="table-content">
                    <p
                      className={`header ${
                        !providerOverviewData?.email ? "error-label" : ""
                      }`}
                    >
                      PROVIDER EMAIL
                    </p>
                    {providerOverviewData?.email ? (
                      <p className="headerValue email">
                        {providerOverviewData?.email}
                      </p>
                    ) : (
                      <a
                        className="update-info-link"
                        onClick={() => {
                          setOpenPopup(!openPopup);
                          setPopupState("overview");
                        }}
                      >
                        Add Email
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {RenderProvidersError()}
          {RenderEditProviderOverview()}
          {RenderPhotosEditPopup()}
        </div>
      )}
    </>
  );
};

export default ProviderOverviewSection;
